import { render, staticRenderFns } from "./menu-time-settings.vue?vue&type=template&id=3b421b26&scoped=true"
import script from "./menu-time-settings.vue?vue&type=script&lang=js"
export * from "./menu-time-settings.vue?vue&type=script&lang=js"
import style0 from "./menu-time-settings.vue?vue&type=style&index=0&id=3b421b26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b421b26",
  null
  
)

export default component.exports